import { useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

function HrSearchBar() {
  
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");

  // Handle search and suggestions
  const handleSearchParams = (e) => {
  e.preventDefault();
  if (searchTerm) {
    const currentPath = location.pathname; // e.g., /employee/payslips
    const newUrl = `${currentPath}?search=${encodeURIComponent(searchTerm)}`;
    navigate(currentPath); 
    navigate(newUrl, { replace: true }); // 🔁 Replace current entry instead of navigating
  }
};

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };


  return (
    <form
      onSubmit={handleSearchParams}
      className="sm:w-72 bg-white border p-2 rounded-full flex items-center shadow-md"
    >
      <input
        type="text"
        placeholder="Search"
        className="bg-transparent focus:outline-none pl-3 pr-2 py-1.5 w-full text-sm"
        value={searchTerm}
        onChange={handleInputChange}
      />
      <button type="submit" className="p-1.5 flex-shrink-0">
        <FaSearch className="text-slate-600 " />
      </button>
    </form>
  );
}

export default HrSearchBar;
